<template>
  <li class="nav-item hidden-lg-down" style="width: 400px; margin-right: 10px;">
    <form role="search" class="app-search">
      <el-select id="global-search" v-model="customer_id" filterable remote clearable :remote-method="searchCustomer"
                 class="form-control" placeholder="Rechercher une fiche dans toute l'interface ..." @change="handleChange" @clear="handleClear">
        <customer v-for="customer in customers" :key="customer.id" :item="customer" present="option"></customer>
      </el-select>
    </form>
  </li>
</template>

<script>
  import Customer from '@db2b/keystone/components/Entities/Customer.vue'

  let $ = window.$

  export default {
    components: {Customer},
    name: 'top-bar-search',
    data () {
      return {
        customer_id: null,
        customers: [],
        lastRouterPath: null
      }
    },
    methods: {
      searchCustomer (query) {
        let self = this

        if (query.length > 2) {
          this.$nexus.get('crm2', 'customers', {params: {where: {name: query}, limit: 20}}).then(response => {
            self.customers = response.data.data
          })
        }
      },
      handleChange (value) {
        if (value !== '') {
          this.lastRouterPath = this.$router.history.current.path
          this.$router.push('/customers/' + value)
        }
      },
      handleClear () {
        this.$router.push(this.lastRouterPath)
      }
    },
    mounted: function () {
      let self = this
      window.addEventListener('keyup', event => {
        let inputFound = false
        let inGlobalSearch = false
        for (let i = 0; i < event.path.length; i++) {
          if (event.path[i].nodeName === 'INPUT' || event.path[i].nodeName === 'TEXTAREA') {
            inputFound = true
            if (event.path[i].parentNode.id === 'global-search') {
              inGlobalSearch = true
            }
          }
        }

        if (inGlobalSearch && event.code === 'Enter') {
          this.$model.customer.fire('search', {
            form: {
              name: $('#global-search input').val()
            }
          })
        }
        if (!inputFound && event.code !== 'Escape' && event.code !== 'Enter' && event.code !== 'AltLeft' && event.code !== 'AltRight') {
          let search = $('#global-search input')
          search.focus()
          setTimeout(() => {
            search.val(event.key)
          })
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// TopBarSearch.vue?4a1a80da